import {z} from 'zod'
import i18n from '@/translations/i18n'
import {GroupMember, UserSmall} from '../users/types'

// User Group Base Schema
export const UserGroup = z.object({
    id: z.string(),
    name: z.string().min(1, {message: i18n.t('errors:required')}),
    members: z.array(GroupMember),
    createdAt: z.string()
})
export type UserGroup = z.infer<typeof UserGroup>

// Schema used for creating a new user group
export const CreateUserGroupSchema = z.object({
    name: z.string().min(1, {message: i18n.t('errors:required')}),
    members: z.array(z.string()).optional()
})
export type CreateUserGroupSchema = z.infer<typeof CreateUserGroupSchema>

// Schema used for updating an existing user group
export const UpdateUserGroupSchema = z.object({
    name: z.string().min(1, {message: i18n.t('errors:required')}),
    members: z.array(z.string()).optional()
})
export type UpdateUserGroupSchema = z.infer<typeof UpdateUserGroupSchema>

// Form validation schema for creating/editing a user group
export const UserGroupFormValidationSchema = z.object({
    name: z.string().min(3, {message: i18n.t('user_groups:error_required_group_name')}),
    members: z.array(UserSmall.shape.id).min(2, {message: i18n.t('user_groups:error_required_members')})
})
export type UserGroupFormValidationSchema = z.infer<typeof UserGroupFormValidationSchema>

// Schema for URL search parameters
export const UserGroupsSearchParams = z.object({
    search: z.string().trim().optional()
})
